import {Component, inject} from '@angular/core';
import {ElciaDialog} from '../dialog/dialog';
import {TranslatePipe} from '@ngx-translate/core';
import {ConfirmService} from '../../services/confirm.service';

@Component({
  selector: 'elcia-confirm-dialog',
  imports: [ElciaDialog, TranslatePipe],
  templateUrl: './confirm-dialog.html',
})
export class ConfirmDialog {
  protected readonly confirmService = inject(ConfirmService);
}
